const env = (configKey) =>
  process.env[`REACT_APP_AWS_COGNITO_${configKey.toUpperCase()}`];

export default {
  authType: env("AUTH_TYPE") || "userpool",
  domain: env("DOMAIN") || "localgraf-dev.auth.us-east-2.amazoncognito.com",

  region: env("REGION") || "us-east-2",
  userPool: {
    id: env("USERPOOL_ID") || "us-east-2_1CYy5W98x",
    clientId: env("USERPOOL_CLIENT_ID") || "25kpfiea8qq40t0n6645vpqcbs"
  },
  flowType: env("FLOW_TYPE") || "USER_PASSWORD_AUTH"
};
